import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';
import TextTruncate from 'react-text-truncate';
import { connect } from 'react-redux';
import { CheckPermission } from 'modules/login/CheckPermission';
import { XuLyYeuCau } from 'modules/dialog';

class RowItemYeuCau extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      type: this.props.type,
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy:'',
      dialogXuly: false
    }
  }

  getListData() {
    this.props.getListData();
  }

  componentDidMount() {

    if (this.props.item.trangThaiDonInfo) {
      this.props.item.trangThaiDonInfo.filter(item => {
        return item.donViId == this.props.userInfo.donViId;
      }).map((child, i) => {
        if (this.props.item.ma && child.ketQuaType === 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Đình chỉ',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else if (!this.props.item.ma && child.ketQuaType === 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Rút đơn',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else {
          this.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        }
      })
    }

    if (this.props.item.canBoDangXuLyInfo) {
      this.props.item.canBoDangXuLyInfo.filter(item => {
        return item.donViId == this.props.userInfo.donViId;
      }).map((child, i) => {
        if (child.hoVaTen != "")
          this.setState({
            canBoXuLy: child.hoVaTen
          })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.type && this.props.type != nextProps.type) {
      this.setState({
        type: nextProps.type
      })
    }
  }
  getLocal(diachi) {
    let dungDon = [];
    if(diachi.diaChi) {
      dungDon.push(diachi.diaChi);
    }
    if(diachi.toThon) {
      dungDon.push(diachi.toThon);
    }
    if(diachi.phuongXaCongDan && diachi.phuongXaCongDan.ten) {
      dungDon.push(diachi.phuongXaCongDan.ten);
    }
    if(diachi.quanHuyenCongDan && diachi.quanHuyenCongDan.ten) {
      dungDon.push(diachi.quanHuyenCongDan.ten);
    }
    if(diachi.tinhThanhCongDan && diachi.tinhThanhCongDan.ten) {
      dungDon.push(diachi.tinhThanhCongDan.ten);
    }
    return dungDon.join(", ");
  }

  showThongTinCongDan() {
    let size = this.props.item.listNguoiDungDon.length;
    if (size) {
      return (
        <div>
          <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
          <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
          <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
        </div>
      )
    }
  }

  showThoiHanXuLyDon() {

    let thoiHanXuLy = {};

    if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

      thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
    } else {
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else if (this.props.item.donViXuLyGiaiQuyetInfo && this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId == this.props.userInfo.donViId) {

        this.props.item.trangThaiDonInfo.filter(item => {
          return item.donViId == this.props.userInfo.donViId;
        }).map((child, i) => {

          if (child.trangThaiDonType === 'DANG_XU_LY')
            thoiHanXuLy = this.props.item.thoiHanXuLyInfo;
          if (child.trangThaiDonType === 'DANG_GIAI_QUYET')
            thoiHanXuLy = this.props.item.thoiHanGiaiQuyetInfo;
        });
      }
    }

    if (thoiHanXuLy.type === 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type === 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  checkNguonDon(type) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let nguonDonText = '';
    let nguonDonDonVi = '';
    let nguonDontype = '';
    let Return = '';
    if (this.props.item.nguonDonInfo) {
      let dataNguonDon = this.props.item.nguonDonInfo.filter(nguonDon => {
        return nguonDon.idDonVi == userInfo.donViId;
      });

      if (dataNguonDon.length > 0) {
        nguonDonText = dataNguonDon[0].nguonDonText;
        nguonDonDonVi = dataNguonDon[0].donViChuyenText;
        nguonDontype = dataNguonDon[0].type;
      } else {
        nguonDonText = this.props.item.nguonDonText;
        nguonDonDonVi = '';
        nguonDontype = '';
      }
    }
    if (type === 'nguonDonText') {
      Return = nguonDonText
    }
    if (type === 'nguonDonDonVi') {
      Return = nguonDonDonVi
    }
    if (type === 'nguonDontype') {
      Return = nguonDontype
    }
    return Return;
  }

  openPopupXuLy(status) {
    this.setState({dialogXuly: status});
  }

  handleClickDetail() {
    this.props.onClickDetail(this.props.item, true);
  }

  render() {
    let nguonDonText = this.checkNguonDon('nguonDonText');
    let nguonDonDonVi = this.checkNguonDon('nguonDonDonVi');
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <ul className="list-items-table">
            <li>{moment(this.props.item.ngayLapDonGapLanhDaoTmp).format('DD/MM/YYYY')}</li>
            <li>{moment(this.props.item.ngayLapDonGapLanhDaoTmp).format('HH:mm')}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <Link className="txt-underline" onClick={this.handleClickDetail.bind(this)} >
                <TextTruncate
                  line={3}
                  truncateText="…"
                  text={this.props.item.noiDung}
                />
              </Link>
            </li>
            <li>
              {this.showThoiHanXuLyDon()}
            </li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {this.props.item.loaiDonInfo ? this.props.item.loaiDonInfo.ten : ''}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li className="txt-italic">{nguonDonDonVi}</li>
            <li>{nguonDonText}</li>
          </ul>
        </td>

        <td>{this.props.item.coQuanDaGiaiQuyetDonThu || ''}</td>

        <td>
          <ul className="list-items-table">
            <li>{this.props.item.trangThaiYeuCauGapLanhDaoInfo ? this.props.item.trangThaiYeuCauGapLanhDaoInfo.ten : ''}</li>
          </ul>
        </td>

        <td>
          <div className="todo-wrap two-item">
            {
              CheckPermission('SOTIEPCONGDAN_XOA') && (!this.props.item.soTiepCongDanYCGLD || (this.props.item.soTiepCongDanYCGLD && !this.props.item.soTiepCongDanYCGLD.hoanThanhTCDLanhDao)) && !this.props.item.dangGiaoKTDX && this.props.item.trangThaiYeuCauGapLanhDao !== 'DONG_Y' ?
                <div className="wrap-link-todo">
                  <Link className="itt-redirect" onClick={this.openPopupXuLy.bind(this, true)}>Xử lý</Link>
                  <XuLyYeuCau trangThaiList={this.props.trangThaiList} open={this.state.dialogXuly} onClose={this.openPopupXuLy.bind(this, false)} data = {this.props.item} onSuccess={this.props.parent.getListData.bind(this.props.parent)}/>
                </div>
              :''
            }
          </div>
        </td>
      </tr>
    )
  }
}

RowItemYeuCau.defaultProps = {
  dataLoaiDonThu: []
}

let bindStateToProps = state => {
  return {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
  }
}

export default connect(bindStateToProps)(RowItemYeuCau);


// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/datatable/list/RowItemYeuCau.jsx